import { Injectable, inject } from '@angular/core';
import { NucleusAccessRequestDataContract } from '@nucleus/access-request-ui';

import { ApplicationConfigService } from '../application-config.service';

/**
 * Supplies @nucleus/access-request-ui's NUCLEUS_ACCESS_REQUEST_DATA contract
 * for the full-page <lib-access-request-management> screen.
 *
 * The lib component injects this token non-optionally (for the permission
 * filter dropdown + label translation + the `isMe` self-action block), so it
 * must be provided wherever the component is hosted — the routed context has
 * no dialog/parent injector to fall back on. Permission codes/labels and the
 * current user id both come from TaskSense's ApplicationConfigService, which
 * is populated at bootstrap from the BFF profile.
 */
@Injectable({ providedIn: 'root' })
export class TasksenseAccessRequestDataAdapter implements NucleusAccessRequestDataContract {
  private readonly config = inject(ApplicationConfigService);

  getPermissionCodes(): string[] {
    return this.config.getPermissions().map((p) => p.permission);
  }

  permissionLabel(code: string): string {
    const match = this.config.getPermissions().find((p) => p.permission === code);
    return match?.description ?? code;
  }

  getCurrentUserId(): string | null {
    const id = this.config.getUserId();
    return id ? id : null;
  }
}
